import { render, staticRenderFns } from "./AddonProductModalMobile.vue?vue&type=template&id=561564fb&scoped=true&"
import script from "./AddonProductModalMobile.vue?vue&type=script&lang=js&"
export * from "./AddonProductModalMobile.vue?vue&type=script&lang=js&"
import style0 from "./AddonProductModalMobile.vue?vue&type=style&index=0&id=561564fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561564fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\corporate-builder\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('561564fb')) {
      api.createRecord('561564fb', component.options)
    } else {
      api.reload('561564fb', component.options)
    }
    module.hot.accept("./AddonProductModalMobile.vue?vue&type=template&id=561564fb&scoped=true&", function () {
      api.rerender('561564fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "CorporateBuilder/components/Step2Mobile/AddonProductModalMobile.vue"
export default component.exports